import React from 'react';

import {
  DescriptionList,
  DescriptionItem,
  TypographyListItem,
  Link,
} from '@gogame/components';

const General = ({ data, onOpenPartnerCompany, onOpenAffiliate }) => {
  return (
    <DescriptionList disableGutters={true} data={data}>
      <DescriptionItem
        onValueClick={onOpenPartnerCompany}
        label={'Partner company'}
        type={'link'}
        field={'partnerCompany'}
        linkLabelField={'name'}
      />

      <DescriptionItem
        label={'Affiliates'}
        type={'typographyList'}
        field={'affiliates'}
        item={({ onClick: _, ...p }) => (
          <Link onClick={(e) => onOpenAffiliate(e, p)}>
            <TypographyListItem {...p} />
          </Link>
        )}
      />

      <DescriptionItem label={'Networks'} field={'networks'} />
      <DescriptionItem label={'Partner integration'} field={'partnerApi'} />
      <DescriptionItem
        label={'Integration start date'}
        field={'startDate'}
        type={'date'}
        template={'LL'}
      />
    </DescriptionList>
  );
};

export default General;
